import { render, staticRenderFns } from "./novel-meta.vue?vue&type=template&id=3ea64a0c&scoped=true"
import script from "./novel-meta.vue?vue&type=script&lang=js"
export * from "./novel-meta.vue?vue&type=script&lang=js"
import style0 from "./novel-meta.vue?vue&type=style&index=0&id=3ea64a0c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea64a0c",
  null
  
)

export default component.exports